import { z } from 'zod'

import { calendarDate, isoDateTime } from '../lib/date'

export const treatmentReminderStatusSchema = z.enum(['active', 'superseded', 'cancelled'])
export type TreatmentReminderStatus = z.infer<typeof treatmentReminderStatusSchema>

/**
 * A reminder target is free text: US regions constrain it to a per-species disease list
 * at the UI level, but UK regions use the vaccine's product name (a UK vaccine maps 1:1
 * to a disease), so the server accepts any non-empty string as the supersede match key.
 */
export const treatmentReminderTargetSchema = z.string().trim().min(1).max(200)

/** A single per-disease booster reminder created by a vaccine administration. */
export const treatmentReminderSchema = z.object({
  id: z.uuid(),
  patientId: z.uuid(),
  /** The vaccination treatment that created this reminder. */
  treatmentId: z.uuid(),
  /** Disease/antigen from the controlled list — the supersede match key. */
  target: z.string(),
  dueAt: calendarDate,
  status: treatmentReminderStatusSchema,
  /** Set only when status='superseded' — the treatment (shot) that superseded this reminder. */
  supersededByTreatmentId: z.uuid().nullable(),
  cancelledAt: isoDateTime.nullable(),
  cancelledBy: z.uuid().nullable(),
  createdAt: isoDateTime,
  updatedAt: isoDateTime,
})

export type TreatmentReminder = z.output<typeof treatmentReminderSchema>
